import { WebAudioNode } from "./node.js";

class WebAudioNodeFilter extends WebAudioNode {
  namespace = "webaudio:node:filter";
}

const webAudioNodeFilter = new WebAudioNodeFilter();
export { webAudioNodeFilter, WebAudioNodeFilter };
